import BaseEntity from '@/entity/BaseEntity';
import { i18n } from '@/i18n';
import { getWeekDatesFromWeekNumber } from '@/utils/tools';

export default class TimeTicketListItemEntity<T extends Armado.TimeTicketWeekYear = Armado.TimeTicketWeekYear> extends BaseEntity<T> {

	get weekNumber () { return this.state.weekNumber }
	get qtyPending () { return this.state.qtyPending }
	get qtyToValidate () { return this.state.qtyToValidate }
	get qtyValidated () { return this.state.qtyValidated }
	get qtyIntegrated () { return this.state.qtyIntegrated }
	get year () { return this.state.year }
	get labelToFillClient () { return this.self.isAgency() ? i18n.global.t('documents.filter.clientInput') : i18n.global.t('documents.toFill') }
	get readableDates () {
		const dates = getWeekDatesFromWeekNumber(this.state.weekNumber, this.state.year);
		return i18n.global.t('documents.fromStartToEndDate', {
			startDate: dates.start.toReadable(),
			endDate: dates.end.toReadable(),
		});
	}

}
